import type { MouseEvent, ReactNode } from 'react';
import { ArrowRight } from 'lucide-react';
import './about.css';

export function CreatorHero({ href, disabled = false, onStart, children }: { children?: ReactNode; href: string; disabled?: boolean; onStart?: (event: MouseEvent<HTMLAnchorElement>) => void }) {
  return (
      <section className="reviewer-about__hero">
        <div className="reviewer-about__hero-inner">
          <div className="reviewer-about__copy">
            <p className="reviewer-about__eyebrow">BEAW.CLUB · BE A REVIEWER.</p>
            <h1>สร้างรายได้จากการเขียน Content รีวิว</h1>
            <a href={href} className="reviewer-about__cta" aria-disabled={disabled || undefined} onClick={event => { if (disabled) event.preventDefault(); else onStart?.(event); }}>เริ่มวันนี้ 10 บาท/ คอนเทนต์ <ArrowRight size={20} /></a>
            <p className="reviewer-about__lead">เปลี่ยนประสบการณ์เป็นรายได้</p>
            {children}
          </div>
          <figure className="reviewer-about__visual">
            <img src="/assets/beaw-reviewer-social.jpg" alt="Beaw.club ชวนทุกคนเป็น Reviewer ค้นหาร้าน แชร์ประสบการณ์จริง และรับ Reward จากร้านที่ร่วมรายการ" width="1254" height="1254" fetchPriority="high" />
          </figure>
        </div>
      </section>
  );
}
